import React from 'react';

import { BrowserRouter } from 'react-router-dom';

import AppRoutes from './app.routes';
import GtmPageView from './GtmPageView';

const Routes: React.FC = () => {
	return(
		<BrowserRouter>
			<GtmPageView />
			<AppRoutes />
		</BrowserRouter>
	);
};

export default Routes;